export default {
	"11b035e8c4da2efd29c6f9082c071b76": "地圖加載出錯了",
	"5b50afe4b7d9b4c86854715312e6d57b": "小區/寫字樓/學校等"
}
